import React from 'react';
import { Row, Col, Form, FormGroup, Label, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Styled from './StyledComponents';
import media from '../mixins';

const StyledSearch = styled(Form)`
  padding: 10px 0;
  color: #999;
  font-family: Raleway;

  label {
    width: 100%;
    margin-bottom: 0;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
  }

  input {
    height: 38px;
    font-family: Raleway;
    font-size: 13px;
    font-weight: normal;
  }

  select {
    font-family: Raleway;
    font-size: 13px;
    font-weight: normal;
  }

  .btn {
    width: 100%;
  }

  .btn-warning {
    ${media.xs`
      margin-top: 10px;
    `}
  }
`;

const Flex = styled(Styled.Flex)`
  height: 100%;
`;

const Search = ({
  searchValues,
  handleSearchChange,
  handleSearchSubmit,
  handleSearchReset,
  propertyCategories,
  propertyTypes,
  propertyStatuses,
  user,
  priceMin,
  priceMax,
}) => (
  <StyledSearch onSubmit={handleSearchSubmit}>
    <Row>
      <Col xs={12} sm={6} md={3}>
        <FormGroup>
          <Label>
            Categories
            <select
              value={searchValues.category_id || ''}
              name="category_id"
              className="form-control"
              onChange={handleSearchChange}
            >
              <option value={''}>All Categories</option>
              {propertyCategories.map(category => (
                <option key={category.id} value={category.id}>{category.name}</option>
              ))}
            </select>
          </Label>
        </FormGroup>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <FormGroup>
          <Label>
            Type
            <select
              value={searchValues.type_id || ''}
              name="type_id"
              className="form-control select"
              onChange={handleSearchChange}
            >
              <option value="">All Types</option>
              {propertyTypes.map(type => (
                <option key={type.id} value={type.id}>{type.name}</option>
              ))}
            </select>
          </Label>
        </FormGroup>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <FormGroup>
          <Label>
            Status
            <select
              value={searchValues.status_id || ''}
              name="status_id"
              className="form-control select"
              onChange={handleSearchChange}
            >
              <option value={''}>All Statuses</option>
              {propertyStatuses.map(status => (
                <option key={status.id} value={status.id}>{status.name}</option>
              ))}
            </select>
          </Label>
        </FormGroup>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <FormGroup>
          <Label>
            Price range {user.currency}
            <Row>
              <Col xs={6}>
                <input
                  value={searchValues.p_min || ''}
                  name="p_min"
                  type="number"
                  placeholder="From"
                  className="form-control"
                  onChange={handleSearchChange}
                  min={priceMin}
                  max={priceMax}
                />
              </Col>
              <Col xs={6}>
                <input
                  value={searchValues.p_max || ''}
                  name="p_max"
                  type="number"
                  placeholder="To"
                  className="form-control"
                  onChange={handleSearchChange}
                  min={priceMin}
                  max={priceMax}
                />
              </Col>
            </Row>
          </Label>
        </FormGroup>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <FormGroup>
          <Label>
            min Beds
            <input
              value={searchValues.bed || ''}
              name="bed"
              type="number"
              placeholder="From"
              className="form-control"
              onChange={handleSearchChange}
            />
          </Label>
        </FormGroup>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <FormGroup>
          <Label>
            min baths
            <input
              value={searchValues.bath || ''}
              name="bath"
              type="number"
              placeholder="From"
              className="form-control"
              onChange={handleSearchChange}
            />
          </Label>
        </FormGroup>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <Flex align="center">
          <Button color="primary" type="submit">Search</Button>
        </Flex>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <Flex align="center">
          <Button color="warning" type="reset" onClick={handleSearchReset}>Reset</Button>
        </Flex>
      </Col>
    </Row>
  </StyledSearch>
);

Search.propTypes = {
  searchValues: PropTypes.object,
  handleSearchChange: PropTypes.func.isRequired,
  handleSearchSubmit: PropTypes.func.isRequired,
  handleSearchReset: PropTypes.func.isRequired,
  propertyCategories: PropTypes.array,
  propertyTypes: PropTypes.array,
  propertyStatuses: PropTypes.array,
  user: PropTypes.object,
  priceMin: PropTypes.number,
  priceMax: PropTypes.number,
};

Search.defaultProps = {
  searchValues: {},
  propertyCategories: [
    {
      id: 1,
      name: 'Sales'
    },
    {
      id: 2,
      name: 'Lettings'
    },
    {
      id: 3,
      name: 'Commercial'
    },
  ],
  propertyTypes: [],
  propertyStatuses: [],
  user: {},
  priceMin: 0,
  priceMax: 1000000,
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js